import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Form from './Form';
import { create, reset } from '../../actions/LiveInterview/create';
import moment from "moment-timezone";

class LiveInterviewCreate extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    created: PropTypes.object,
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    if (this.props.created)
      this.props.history.push({
        pathname: `/company/live-interview-schedules/show/${encodeURIComponent(this.props.created['@id'])}`,
        state: {successMessage: 'Live Interview successfully created.'}
      });

    let initialValues = {
      recordingEnabled: true,
      companyUserInvitations: [],
      candidateInvitations: [],
      timezone: moment.tz.guess()
    };
    if (this.props.match.params.jobId) {
      initialValues['job'] = decodeURIComponent(this.props.match.params.jobId);
    }

    return (
      <div>
        <h1>Schedule Live Interview</h1>

        {this.props.loading && (
          <div className="alert alert-info" role="status">
            Loading...
          </div>
        )}
        {this.props.error && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.error}
          </div>
        )}

        <Form
          onSubmit={this.props.create}
          initialValues={initialValues}
          isNew={true}
        />
        <Link to="." className="btn btn-primary float-left mr-3">
          Back to list
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { created, error, loading } = state.liveinterview.create;
  return { created, error, loading };
};

const mapDispatchToProps = dispatch => ({
  create: values => dispatch(create(values)),
  reset: () => dispatch(reset())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveInterviewCreate);
